import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import siteSettings from '../../config/site-settings';
import {Language} from '../../config/language';

@Component({
  selector: 'app-sh-logo',
  templateUrl: './logo.component.html',
  styleUrls: ['./logo.component.scss']
})
export class LogoComponent implements OnInit {

  siteSettings = siteSettings;
  language = Language;

  constructor(private router: Router) {
  }

  ngOnInit(): void {
  }

  gotoPortal(): void {
    const currentLang = localStorage.getItem('currentLang') || 'ru';
    const token = localStorage.getItem('access_token');
    
    // Only include token in URL if it exists and is not 'null'
    const tokenParam = token && token !== 'null' ? `access_token=${token}&` : '';
    
    if (location.href === 'https://geopavlodar.kz/map/layer-themes') {
      window.location.href = `https://geopavlodar.kz/#/?${tokenParam}lang=${currentLang}`;
    } else {
      window.location.href = `http://geopavlodar.kz/#/?${tokenParam}lang=${currentLang}`;
    }
  }
}
